export default __webpack_public_path__ + "static/viz/media/postgresql.57523305.svg";